import {Card} from "../scorecard/model/scorecard-model";
import {ScoringMethod} from "../scorecard/model/scoring-method";

export interface Round {
    info: RoundInfo | undefined
    settings: RoundSettings
    scorecard: Scorecard
}

export interface RoundInfo {
    startTimestampMs: number,
    timezoneOffset: number
}

export interface RoundSettings {
    course: Course,
    scoringMethod: ScoringMethod,
    handicapMode: HandicapMode
}

export interface Course {
    name: string
    holes: Hole[]
}

export enum HandicapMode {
    Gross = "Gross",
    Net = "Net"
}

interface Hole {
    par: number,
    parOverride: number | null,
    handicap: number,
    tee: Position,
    greenMiddle: Position,
}

export interface Scorecard {
    cards: Card[]
}

export interface Position {
    lat: number
    lon: number
}